import { useLocalization } from '@/hooks/useLocalization';
import { useChat } from '@/hooks/useChat';
import BotMessage from '@/components/ChatMessage/BotMessage';
import ChannelButton from '@/components/ChannelButton/ChannelButton';
import styles from '@/styles/chat.module.scss';

const ChatIcon = () => (
  <svg viewBox="0 0 24 24" style={{ width: 18, height: 18, fill: '#1a6fcc' }}>
    <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" />
  </svg>
);

const EmailIcon = () => (
  <svg viewBox="0 0 24 24" style={{ width: 18, height: 18, fill: '#e85d26' }}>
    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
  </svg>
);

// const TelegramIcon = () => (
//   <svg viewBox="0 0 24 24" style={{ width: 18, height: 18, fill: '#0088cc' }}>
//     <path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z" />
//   </svg>
// );

export default function ChannelScreen() {
  const { t } = useLocalization();
  const { chooseChannel } = useChat();

  return (
    <BotMessage text={t('channel.message')}>
      <div className={styles.channelOptions}>
        <ChannelButton
          icon={<ChatIcon />}
          iconBg="#e3f0fd"
          label={t('channel.chat')}
          onClick={() => chooseChannel('chat')}
        />
        <ChannelButton
          icon={<EmailIcon />}
          iconBg="#fff3e0"
          label={t('channel.email')}
          onClick={() => chooseChannel('email')}
        />
        {/* <ChannelButton
          icon={<TelegramIcon />}
          iconBg="#e3f5ff"
          label={t('channel.telegram')}
          onClick={() => chooseChannel('telegram')}
        /> */}
      </div>
    </BotMessage>
  );
}
